import { UserRoleCRM } from '@crm/types/userRoleCrm'
import { useSessionContext } from '@shared/hooks'

export const useRolePermission = (roles: UserRoleCRM[]) => {
  const { user } = useSessionContext()
  const role = user?.current_application?.application_role as UserRoleCRM

  const isAllowRole = roles.includes(role)

  return isAllowRole
}
